import Area from '@/models/Area';
import { ChevronLeftIcon } from '@heroicons/react/24/outline';
import { Fragment } from 'react/jsx-runtime';
import useStack from '@/data/hook/useStack';
import IconButton from '@/components/ui/custom/buttons/IconButton';
import Text from '@/components/ui/custom/dataDisplay/Text';

type TopBarProps = {
  stack: ReturnType<typeof useStack<Area>>;
};

const TopBar = ({ stack }: TopBarProps) => {
  return (
    <header className="flex w-full gap-2.5 items-center">
      <IconButton
        icon={<ChevronLeftIcon className="h-4 w-4" />}
        onClick={() => stack.pop()}
        type="button"
      />

      <div className="flex gap-1.5">
        {stack.value.map(area => (
          <Fragment key={area.id}>
            <Text text={area.name} className="text-12" />
            <Text
              key={area.id}
              text=">"
              className="text-12 last-of-type:hidden"
            />
          </Fragment>
        ))}
      </div>
    </header>
  );
};

export default TopBar;
